import { render } from "./PassActionButtons.vue?vue&type=template&id=458159b7"
import script from "./PassActionButtons.vue?vue&type=script&lang=js"
export * from "./PassActionButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__